import { useEffect } from "react"
import Block from "@/components/wrappers/block"
import BlockHeader from "@/common/partials/block-header/block-header"
import classNames from "classnames"
import styles from "./wufoo.module.css"

function WufooForm({ block }) {
  const {
    attrs: {
      heading,
      text,
      bgColor = "transparent",
      blockGap,
      formHash,
      layout
    }
  } = block

  useEffect(() => {
    ;(function (d, t) {
      var s = d.createElement(t),
        options = {
          userName: "naturskyddsforeningen",
          formHash: formHash,
          autoResize: true,
          height: "555",
          async: true,
          host: "wufoo.com",
          header: "show",
          ssl: true
        }
      s.src =
        ("https:" == d.location.protocol ? "https://" : "http://") +
        "secure.wufoo.com/scripts/embed/form.js"
      s.onload = s.onreadystatechange = function () {
        var rs = this.readyState
        if (rs) if (rs != "complete") if (rs != "loaded") return
        try {
          const form = new window.WufooForm()
          form.initialize(options)
          form.display()
        } catch (e) {
          console.error(e)
        }
      }
      s.id = "wufoo-script"
      var scr = d.getElementsByTagName(t)[0],
        par = scr.parentNode

      par.insertBefore(s, scr)
    })(window.document, "script")

    return () => {
      window.document.getElementById("wufoo-script")?.remove()
    }
  }, [formHash])

  return (
    <Block
      width="bleed"
      innerWrapper={true}
      gap={blockGap}
      className={classNames(
        styles.wrapper,
        "layout-" + layout,
        "bg-color-" + bgColor
      )}>
      <BlockHeader heading={heading} text={text} className="max-w-1xl" />
      <div className={styles.form} id={`wufoo-${formHash}`} />
    </Block>
  )
}

export default WufooForm
